<template>
  <div class="members">
    <el-row :gutter="24" class="stats-row">
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-user-solid" style="color: #c0c4cc;"></i> 总会员数</p>
          <div class="stat-value-wrap">
            <span class="stat-value">{{ formatNumber(stats.totalMembers) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-circle-check" style="color: #E4393C;"></i> 有效会员数</p>
          <div class="stat-value-wrap">
            <span class="stat-value danger">{{ formatNumber(stats.validMembers) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-star-off" style="color: #e6a23c;"></i> 业务经理数</p>
          <div class="stat-value-wrap">
            <span class="stat-value warning">{{ formatNumber(stats.managers) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never" class="stat-card">
          <p class="stat-label"><i class="el-icon-user" style="color: #409EFF;"></i> 本月新增会员</p>
          <div class="stat-value-wrap">
            <span class="stat-value info">{{ formatNumber(stats.monthNew) }}</span>
            <span class="stat-unit">人</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="member-card">
      <div class="search-bar">
        <el-input v-model="memberSearch" placeholder="搜索会员昵称/手机号/所属分身" prefix-icon="el-icon-search" size="small" style="width: 300px;" clearable />
        <el-select v-model="identityFilter" placeholder="会员身份（全部）" size="small" style="width: 160px;" clearable>
          <el-option label="普通粉丝" :value="0" />
          <el-option label="有效会员" :value="1" />
          <el-option label="业务经理" :value="2" />
        </el-select>
        <el-select v-model="branchFilter" placeholder="所属分身（全部）" size="small" style="width: 160px;" clearable>
          <el-option v-for="b in branchOptions" :key="b.id" :label="b.name" :value="b.id" />
        </el-select>
        <el-button type="danger" size="small" @click="handleSearch">搜索</el-button>
        <el-button size="small" @click="resetFilter">重置</el-button>
      </div>

      <el-table :data="memberList" style="width: 100%;" border stripe v-loading="loading">
        <el-table-column prop="id" label="会员ID" width="100" />
        <el-table-column label="头像" width="70">
          <template slot-scope="scope">
            <el-avatar :size="36" icon="el-icon-user-solid" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="昵称" width="120" />
        <el-table-column prop="phone" label="手机号" width="140" />
        <el-table-column label="会员身份" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.identity_code === 2 ? 'warning' : scope.row.identity_code === 1 ? 'success' : 'info'" size="small">{{ scope.row.identity }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="branch" label="所属分身" width="140">
          <template slot-scope="scope">
            <span class="branch-name">{{ scope.row.branch }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计消费额" width="120">
          <template slot-scope="scope">
            <span class="price-bold">¥{{ scope.row.totalSpent }}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" width="180">
          <template slot-scope="scope">{{ scope.row.registerTime | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="最后活跃时间" width="180">
          <template slot-scope="scope">{{ scope.row.lastActive | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <span>共 {{ total }} 条记录</span>
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit" :current-page.sync="page" @current-change="fetchMembers" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getMembers } from '@/api'

export default {
  name: 'Members',
  data() {
    return {
      memberSearch: '',
      identityFilter: '',
      branchFilter: '',
      memberList: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,
      stats: { totalMembers: 0, validMembers: 0, managers: 0, monthNew: 0 },
      branchOptions: []
    }
  },
  mounted() {
    this.fetchMembers()
  },
  methods: {
    formatNumber(num) {
      return num ? num.toLocaleString() : '0'
    },
    fetchMembers() {
      this.loading = true
      const params = { page: this.page, limit: this.limit }
      if (this.memberSearch) params.keyword = this.memberSearch
      if (this.identityFilter !== '') params.member_type = this.identityFilter
      if (this.branchFilter) params.branch_id = this.branchFilter

      getMembers(params).then(res => {
        this.memberList = res.list || []
        this.total = res.total || 0
        if (res.stats) this.stats = res.stats
        if (res.branches) this.branchOptions = res.branches
      }).catch(() => {
        this.$message.error('获取会员列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.page = 1
      this.fetchMembers()
    },
    resetFilter() {
      this.memberSearch = ''
      this.identityFilter = ''
      this.branchFilter = ''
      this.page = 1
      this.fetchMembers()
    },
    handleDetail(row) { this.$message.info(`查看会员详情: ${row.name}`) }
  }
}
</script>

<style scoped>
.stats-row { margin-bottom: 24px; }
.stat-card { border-radius: 8px; border: 1px solid #ebeef5; }
.stat-label { font-size: 12px; color: #909399; margin: 0 0 8px; display: flex; align-items: center; gap: 4px; }
.stat-value-wrap { display: flex; align-items: flex-end; gap: 4px; }
.stat-value { font-size: 28px; font-weight: bold; color: #303133; }
.stat-value.danger { color: #E4393C; }
.stat-value.warning { color: #e6a23c; }
.stat-value.info { color: #409EFF; }
.stat-unit { font-size: 12px; color: #c0c4cc; margin-bottom: 4px; }
.member-card { border-radius: 8px; }
.search-bar { display: flex; align-items: center; gap: 12px; padding: 0 0 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 16px; flex-wrap: wrap; }
.branch-name { color: #409EFF; }
.price-bold { font-weight: bold; }
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
</style>
